export default "__VITE_ASSET__Ci9IcYEU__"